import { FormProvider, useForm } from "react-hook-form";

import ModalOutlet from "../router/ModalOutlet";

export interface CreditCardForm {
  card_number: string;
  card_expiration: string;
  otp: string;
}

const CreditCardModalWrap = () => {
  const formMethods = useForm<CreditCardForm>();

  return (
    <div className="max-w-[32.5rem]">
      <FormProvider {...formMethods}>{<ModalOutlet />}</FormProvider>
    </div>
  );
};

export default CreditCardModalWrap;
